import {ExtendedError} from '../../../libs/shared/helpers/src/types/customErrors';

/*
 * Type.
 */

export class PrefetcherError extends ExtendedError {
  constructor(key: string, originalError: Error) {
    super(`Prefetcher failed: ${key}`, originalError);

    this.key = key;
  }

  readonly key: string;
}
